// Only what en-GB says differently; every other string is en-US (mergeLocaleResources).
export const assets = {
  model: {
    placeTypes: {
      car_park: 'Car park',
    },
  },
  presets: {
    names: {
      office_block: 'Office block',
      data_centre: 'Data centre',
      shopping_centre: 'Shopping centre',
    },
    descriptions: {
      shopping_centre: 'Retail units on each floor, a food court and parking.',
    },
    extras: {
      car_park: 'Car park',
    },
    types: {
      lift: 'Lift',
    },
    fields: {
      leveller: 'Dock leveller',
    },
  },
} as const;
